import { Policy } from "src/app/models/user-policies.model";
import { ReduxWrapper } from "../app.state";

export class UserPoliciesState {
	policies!: ReduxWrapper<Policy[]>
}

export const policyDefaultValue = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value:[]
};

export const userPoliciesInitialState: UserPoliciesState = {
	policies: policyDefaultValue,
};
